// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

// Third party
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

// Local
import { IFilterControl } from '../../../types/internal-interfaces';
import { TextInputConfig } from './text-input-config';

@UntilDestroy()
@Component({
  selector: 'text-input',
  templateUrl: 'text-input.component.html',
  styleUrls: ['text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInputComponent implements OnInit, IFilterControl {
  @Input() configuration: TextInputConfig;

  @Output() filterUpdated: EventEmitter<string> = new EventEmitter();
  @Output() optionsSelectedCountUpdated: EventEmitter<number> =
    new EventEmitter();

  inputValue: string;
  selectedOptionsCount: number = 0;

  private inputThrottle: Subject<string> = new Subject<string>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // throttle textbox input changes
    this.inputThrottle
      .pipe(debounceTime(50), untilDestroyed(this))
      .subscribe((input: string) => {
        this.selectedOptionsCount = input ? 1 : 0;
        this.optionsSelectedCountUpdated.emit(this.selectedOptionsCount);

        this.filterUpdated.emit(input);
      });
  }

  public setValue(currentOption: string): void {
    this.selectedOptionsCount = currentOption ? 1 : 0;
    this.inputValue = currentOption;

    this.optionsSelectedCountUpdated.emit(this.selectedOptionsCount);
    this.cdr.detectChanges();
  }

  public onInputChange(input: string): void {
    this.inputThrottle.next(input);
  }

  public clear(): void {
    this.inputValue = null;
    this.onInputChange(null);
  }
}
